/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockManageSummaryResVo
 */
export interface StockManageSummaryResVo {
    /**
     * SKU数
     * @type {number}
     * @memberof StockManageSummaryResVo
     */
    skuCount?: number;
    /**
     * 商品总数
     * @type {number}
     * @memberof StockManageSummaryResVo
     */
    totalItemQty?: number;
    /**
     * 库存商品体积(CBM)
     * @type {number}
     * @memberof StockManageSummaryResVo
     */
    totalCbm?: number;
    /**
     * 余额(韩币)
     * @type {number}
     * @memberof StockManageSummaryResVo
     */
    walletBalanceKrw?: number;
    /**
     * 今日保管费(韩币)
     * @type {number}
     * @memberof StockManageSummaryResVo
     */
    todayStorageFeeKrw?: number;
    /**
     * 待支付仓储费账单数量
     * @type {number}
     * @memberof StockManageSummaryResVo
     */
    unpaidStorageFeeBillCount?: number;
}

/**
 * Check if a given object implements the StockManageSummaryResVo interface.
 */
export function instanceOfStockManageSummaryResVo(value: object): value is StockManageSummaryResVo {
    return true;
}

export function StockManageSummaryResVoFromJSON(json: any): StockManageSummaryResVo {
    return StockManageSummaryResVoFromJSONTyped(json, false);
}

export function StockManageSummaryResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockManageSummaryResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'totalItemQty': json['totalItemQty'] == null ? undefined : json['totalItemQty'],
        'totalCbm': json['totalCbm'] == null ? undefined : json['totalCbm'],
        'walletBalanceKrw': json['walletBalanceKrw'] == null ? undefined : json['walletBalanceKrw'],
        'todayStorageFeeKrw': json['todayStorageFeeKrw'] == null ? undefined : json['todayStorageFeeKrw'],
        'unpaidStorageFeeBillCount': json['unpaidStorageFeeBillCount'] == null ? undefined : json['unpaidStorageFeeBillCount'],
    };
}

export function StockManageSummaryResVoToJSON(json: any): StockManageSummaryResVo {
    return StockManageSummaryResVoToJSONTyped(json, false);
}

export function StockManageSummaryResVoToJSONTyped(value?: StockManageSummaryResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuCount': value['skuCount'],
        'totalItemQty': value['totalItemQty'],
        'totalCbm': value['totalCbm'],
        'walletBalanceKrw': value['walletBalanceKrw'],
        'todayStorageFeeKrw': value['todayStorageFeeKrw'],
        'unpaidStorageFeeBillCount': value['unpaidStorageFeeBillCount'],
    };
}

